"use strict";

import Vue from 'vue';
import axios from "axios";
import store from "../store";
import router from "../router";

// Full config:  https://github.com/axios/axios#request-config

let config = {};


const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
     // redirect if 403 error 
     if(error.response && error.response.status === 403){
      store.commit("SET_SESSION_EXPIRED", true);
      store.dispatch("logout").then(() => {
        router.push({name: 'login'});
      });
      return;
  
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {

    Vue.axios = _axios;
    window.axios = _axios;

    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },

    });

};

Vue.use(Plugin)

export default Plugin;
